import styled from 'styled-components'

export const ProductsBox = styled.div`
  width: 100%;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`
export const ItemCard = styled.div`
  min-width: 240px;
  max-width: 250px;
  background-color: var(--color-white);
  border-radius: 5px;
  text-decoration: none;
  color: var(--color-font);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 15px;

  & div {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
  }
  & form {
    display: flex;
    width: 100%;
  }
  @media (max-width: 1440px) {
    & {
      width: 30%;
    }
  }
  @media (max-width: 1140px) {
    & {
      width: 40%;
    }
  }
  @media (max-width: 540px) {
    & {
      width: 100%;
    }
  }
`
export const ProductCardPrice = styled.div`
  display: flex;
  justify-content: space-between;

  & div {
    width: auto;
    display: flex;
    flex-direction: column;
  }
`
export const CardPrice = styled.h3``

export const CardPriceOld = styled.h5`
  color: rgb(100, 100, 100);
  font-weight: 500;
`

export const PercentPromotion = styled.h5`
  height: 22px;
  width: auto;
  font-size: 12px;
  color: white;
  background-color: green;
  padding: 4px 6px;
  border-radius: 5px;
`

export const ImageBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  width: 100%;
  height: 200px;
  padding: 0;
  border-bottom: 1px solid #eee;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  overflow: hidden;

  & a {
    padding: 0;
  }

  & img {
    width: 200px;
  }
`

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
`

export const Application = styled.p`
  font-size: 15px;
  margin: 5px 0;
`
export const Description = styled.p`
  margin: 5px 0;
  font-size: 15px;
`
export const Form = styled.form`
  padding: 5px 0 10px 0;
  display: flex;
  & input,
  button {
    width: 50%;
  }
`
export const ApplicationBox = styled.div`
  display: flex;
`

export const CardButton = styled.button`
  cursor: pointer;
  background: ${({ background, contained }) =>
    contained ? background || 'transparent' : 'transparent'};
  color: ${({ color }) => (color ? color : '#333')};
  font-weight: 500;
  font-size: 16px;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: none;
  outline: ${({ contained, color }) =>
    contained ? 'none' : '1px solid ' + (color ? color : '#333')};
  transition: all 0.2s;

  &:hover {
    filter: brightness(0.6);
  }
`
